import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnchorModel, RowBuilder } from 'src/app/shared/models/node';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss']
})
export class RowComponent implements OnInit {

  @Input() preview: boolean = false;
  @Input() rowId: string = '';
  @Input() lang: string = '';
  @Input() position: number = 0;
  @Input() offerta_formativa_id: any;
  @Input() content_type: string = '';
  @Output() objAnchor = new EventEmitter<AnchorModel>();
  public anchorId: string = '';

  public waitRow = false;
  public waitNewsletter = false;
  public cols: any;
  public titleRow: string = '';
  public blockItemsRow: any;
  public setContainer: boolean = false;

  constructor(private nodeService: NodeService) { }

  ngOnInit(): void {
    this.getRow();
  }

  private getRow() {
    this.waitRow = true;
    this.nodeService.getRow(this.rowId, this.lang, this.preview).subscribe((res: RowBuilder[]) => {
      if (res && res[0] && res[0].Row_blocks && res[0].Row_blocks.length) {
        this.manageRowResponse(res);
      } else {
        this.nodeService.getRow(this.rowId, this.lang, this.preview, true).subscribe((res: RowBuilder[]) => { 
          this.manageRowResponse(res);
        }, err => {
          this.nodeService.showError(err);
          this.waitRow = false;
        })
      }
    }, err => {
      this.nodeService.showError(err);
      this.waitRow = false;
    });
  };

  private manageRowResponse(res: RowBuilder[]) {
    if (res && res.length) {
      this.cols = res[0].Row_blocks;
      //Passo preview ai blocchi
      this.cols.forEach((el: any, idx: number) => {
        this.cols[idx].preview = this.preview
      });
      this.getItemsFromBundle(this.cols);
      this.setContainerClass(this.cols);
      this.titleRow = res[0].Title;
      if (res[0].field_ancora && (res[0].Row_blocks.length > 0)) {
        this.anchorId = res[0].field_ancora.replaceAll(' ', '-').toLocaleLowerCase();
        this.objAnchor.emit({
          idRow: this.anchorId,
          labelRow: res[0].field_ancora,
          position: this.position
        });
      }
    }
    this.waitRow = false;
  }

  private setContainerClass(cols: any) {
    for (const col of cols) {
      if (col.colonne_occupate === '4') {
        switch (col.bundle) {
          case 'blocco_ultime_news_in_evidenza':
            this.setContainer = true;
            break;
          case 'blocco_ultime_news_di_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_eventi_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_avvisi_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_eventi_in_evidenza':
            this.setContainer = true;
            break;
          case 'blocco_tutti_i_centri_di_ricerca':
            this.setContainer = true;
            break;
          case 'blocco_tutti_gli_alloggi':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_news':
            this.setContainer = true;
            break;
          case 'blocco_pagine_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_tutti_gli_avvisi':
            this.setContainer = true;
            break;
          case 'blocco_tutti_gli_eventi':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_convenzioni':
            this.setContainer = true;
            break;
          case 'blocco_tutti_i_bandi_per_categor':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_procedure_faq':
            this.setContainer = true;
            break;
          case 'blocco_corsi_di_laurea_ricerca_':
            this.setContainer = true;
            break;
          case 'blocco_vista_pagine_speciali_3':
            this.setContainer = true;
            break;
          case 'blocco_procedure_e_faq_ultime_ca':
            this.setContainer = true;
            break;
          case 'blocco_procedure_e_faq_categorie':
            this.setContainer = true;
            break;
          case 'blocco_corsi_di_laurea_tutti_':
            this.setContainer = true;
            break;
          case 'blocco_docenti_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_persone_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_docenti_tutti_':
            this.setContainer = true;
            break;
          case 'blocco_jumbotron_1':
            this.setContainer = true;
            break;
          case 'blocco_visore_hero_1':
            this.setContainer = true;
            break;
          case 'blocco_ricerca_biblioteca':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_convenzioni':
            this.setContainer = true;
            break;
          case 'blocco_convenzioni_sport':
            this.setContainer = true;
            break;
          case 'blocco_registrazione_avvisi':
            this.setContainer = true;
            break;
          default:
            this.setContainer = false;
            break;
        }
      } else {
        switch (col.bundle) {
          case 'blocco_ultime_news_in_evidenza':
            this.setContainer = true;
            break;
          case 'blocco_ultime_news_di_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_eventi_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_avvisi_categoria':
            this.setContainer = true;
            break;
          case 'blocco_ultimi_eventi_in_evidenza':
            this.setContainer = true;
            break;
          case 'blocco_tutti_i_centri_di_ricerca':
            this.setContainer = true;
            break;
          case 'blocco_tutti_gli_alloggi':
            this.setContainer = true;
            break;
          case 'blocco_pagine_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_tutti_gli_eventi':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_convenzioni':
            this.setContainer = true;
            break;
          case 'blocco_tutti_i_bandi_per_categor':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_procedure_faq':
            this.setContainer = true;
            break;
          case 'blocco_corsi_di_laurea_ricerca_':
            this.setContainer = true;
            break;
          case 'blocco_vista_pagine_speciali_3':
            this.setContainer = true;
            break;
          case 'blocco_procedure_e_faq_ultime_ca':
            this.setContainer = true;
            break;
          case 'blocco_procedure_e_faq_categorie':
            this.setContainer = true;
            break;
          case 'blocco_corsi_di_laurea_tutti_':
            this.setContainer = true;
            break;
          case 'blocco_docenti_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_persone_categorie_':
            this.setContainer = true;
            break;
          case 'blocco_docenti_tutti_':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_news':
            this.setContainer = true;
            break;
          case 'blocco_ricerca_biblioteca':
            this.setContainer = true;
            break;
          case 'blocco_tutte_le_convenzioni':
            this.setContainer = true;
            break;
          case 'blocco_convenzioni_sport':
            this.setContainer = true;
            break;
          default:
            this.setContainer = false;
            break;
        }
      }
    }
  };

  private getItemsFromBundle(cols: any) {
    for (const col of cols) {
      switch (col.bundle) {
        case 'blocco_immagine':
          col.items = col.set_immagini;
          break;
        case 'blocco_video':
          col.items = col.set_video;
          break;
        case 'blocco_numero':
          col.items = col.set_numeri;
          break;
        case 'blocco_card':
          col.items = col.set_card;
          break;
        case 'blocco_card_stack':
          col.items = col.set_card;
          break;
        case 'blocco_quote_testimonial':
          col.items = col.set_quote_testimonial;
          break;
        case 'blocco_accordion':
          col.items = col.set_accordion;
          break;
        case 'blocco_date_to_remember':
          col.items = col.set_date;
          break;
        case 'blocco_pulsante':
          col.items = col.set_pulsanti;
          break;
        case 'blocco_paragrafo_immagine':
          col.items = col.set_paragrafo_immagine;
          break;
        case 'blocco_tab':
          col.items = col.set_tab;
          break;
        case 'blocco_checklist':
          col.items = col.elenco_step;
          break;
        case 'blocco_timeline':
          col.items = col.set_elementi_timeline;
          break;
        case 'blocco_feature':
          col.items = col.set_feature;
          break;
        case 'blocco_visore_hero_1':
          col.items = col.set_visore_hero_1;
          break;
        case 'blocco_alert':
          col.items = col.set_alert;
          break;
        case 'blocco_paragrafo_1':
          col.items = col.set_paragrafi;
          break;
        case 'blocco_modale':
          col.items = col.set_elementi_modale;
          break;
        case 'blocco_persona_docente':
          col.items = col.persona_docente;
          break;
        case 'blocco_bando':
          col.items = col.cerca_bando;
          break;
        case 'blocco_logo':
          col.items = col.set_loghi;
          break;
        default:
          col.items = [];
          break;
      }
    }
  };

}
